let swiperInstance;

function initSwiperIfMobile() {
  const container = document.querySelector('.benefits');

  if (window.innerWidth < 768) {
    if (!swiperInstance && container.classList.contains('swiper')) {
      swiperInstance = new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 8,
        breakpoints: {
          375: {
            slidesPerView: 1.2,
            spaceBetween: 8,
          },
          480: {
            slidesPerView: 2.1,
            spaceBetween: 8,
          },
          640: {
            slidesPerView: 2.4,
            spaceBetween: 8,
          },
        },
        loop: false,
        navigation: {
          nextEl: '.carousel__slider-nav .swiper-button-next',
          prevEl: '.carousel__slider-nav .swiper-button-prev',
        },
      });
    }
  } else {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', initSwiperIfMobile);
window.addEventListener('resize', function () {
  clearTimeout(window.__swiperResizeTimeout);
  window.__swiperResizeTimeout = setTimeout(initSwiperIfMobile, 200);
});
